import { EXPLORA_ROUTES } from 'app/explora-routes';
import { useExploraState } from 'app/store/explora-context';
import useWindowSize from 'hooks/useWindowSize';
import React from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from 'shared/components/PrimaryButton/PrimaryButton';
import TextBody from 'shared/components/TextBody/TextBody';
import TextHeadline from 'shared/components/TextHeadline/TextHeadline';
import WithBackground from 'shared/hoc/WithBackground';
import { FontColor, FontSize } from 'shared/styles/typography';
import './BriefInfo.scss';

const BriefInfo = () => {
  const history = useHistory();
  const { isLTLaptop } = useWindowSize();
  const { homeContent } = useExploraState();
  const { briefInfo } = homeContent;

  return (
    <WithBackground imageName="brief-info" position="top">
      <div className="brief-info-container">
        <div className="brief-info-container__header-container">
          <TextHeadline bold component="h1" color={FontColor.PrimaryMain} size={FontSize.Medium}>
            {briefInfo.title}
          </TextHeadline>
          {!isLTLaptop && (
            <PrimaryButton
              backgroundColor={FontColor.PrimaryLight}
              onClick={() => history.push(EXPLORA_ROUTES.Us)}
              style={{ marginTop: '1rem' }}
            >
              <TextBody component="span" size={FontSize.Medium}>
                Conócenos
              </TextBody>
            </PrimaryButton>
          )}
        </div>
        <div className="brief-info-container__text-container">
          <TextBody component="h2" color={FontColor.PrimaryLight} size={FontSize.Medium} bold>
            {briefInfo.subtitle}
          </TextBody>
          <TextBody component="h3" color={FontColor.SecondaryDark} size={FontSize.Medium} style={{ marginTop: '0.5rem' }}>
            {briefInfo.body}
          </TextBody>
        </div>
        {isLTLaptop && (
          <div>
            <PrimaryButton
              backgroundColor={FontColor.PrimaryLight}
              onClick={() => history.push(EXPLORA_ROUTES.Us)}
              style={{ marginTop: '1rem' }}
            >
              <TextBody component="span" size={FontSize.Medium}>
                Conócenos
              </TextBody>
            </PrimaryButton>
          </div>
        )}
      </div>
    </WithBackground>
  );
};

export default BriefInfo;
